import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * Tooltip - использует $.powertip
 * основной аттрибут - tooltip
 * дополнительные свойства беруться из атррибутов:
 * placement
 * smartPlacement
 * popupClass
 * manual
 * mouseOnToPopup
 * openEvents
 * closeEvents
 * title
 * одноименные свойства powerTip
 */
export class TooltipsBehaviour extends BaseEmptyPrefixControlBehaviour {
    private properties: any = {
        0: {
            placement: 'placement',
            smartplacement: 'smartPlacement',
            popupclass: 'popupClass',
            manual: 'manual',
            mouseontopopup: 'mouseOnToPopup',
            openevents: 'openEvents',
            closeevents: 'closeEvents',
        },
    };

    constructor() {
        super('tooltip');
    }

    getTagName(): string {
        return this.tag;
    }

    protected installCondition(element: any): boolean {
        const jq: any = $;

        return !!jq.powerTip;
    }

    protected installBehaviour(element: HTMLElement): void {
        let tooltip: any = Utils.getObjectByAttributes(
            this.tag,
            element,
            (p, l) => this.propertyTranslator(p, l),
            {}
        );
        if (tooltip.type) {
            tooltip = $.extend(
                true,
                {},
                this.options.types.tooltip[tooltip.type] || {},
                tooltip
            );
            tooltip.type = undefined;
        }

        if (tooltip.title) {
            $(element).attr('title', tooltip.title);
        }
        $(element).powerTip(tooltip);
    }

    private propertyTranslator(property: string, level: number): string {
        const levelObj = this.properties[level];
        if (levelObj) {
            const result = levelObj[property];
            if (result) return result;
        }
        return property;
    }
}


if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.TooltipsBehaviour = TooltipsBehaviour;